/**
 * SitStat sidebar placeholder. When Hub SitStat is selected with the map
 * visible, UscgMapLayout owns the dual-rail workspace instead of this view.
 */
export function SitStatView() {
  return null;
}
